import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

import languageIconBlack from '../../../images/language-icon-black.svg';
import languageIcon from '../../../images/language-icon.svg';

const Toggle = styled.button`
  font-size: 14px;
  text-decoration: none;
  line-height: 16px;
  cursor: pointer;
  display: ${props =>
    props.currentLocale === props.language ? 'none' : 'flex'};
  &::before {
    content: '';
    height: 12px;
    width: 12px;
    background-image: url(${languageIcon});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 0.5rem;
    align-self: center;
  }
  &:focus,
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  &.long {
    width: fit-content;
    margin-top: 0.625rem;
    border-radius: 1.25rem;
    border: 1px solid ${themeGet('colors.white')};
    padding: 0.56rem 1.88rem;

    @media only screen and (min-width: 691px) {
      margin-left: auto;
    }
  }

  &.short {
    padding: 0 1.1rem;
    align-items: center;
    &::before {
      height: 22px;
      width: 22px;
      background-image: url(${languageIconBlack});
      margin-right: 0.3rem;
    }
    display: none;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      display: flex;
    }
  }

  &.show {
    display: flex;
  }
`;

export default Toggle;
